import Vue from 'vue'
import MNavigationBar from '@/components/mobile/navigation-bar.vue'
import MFooter from '@/components/mobile/footer.vue'
Vue.component('MNavigationBar',MNavigationBar)
Vue.component('MFooter',MFooter)